<template>
    <el-form ref="form" :rules="isMode ? {} : rules" :model="dioForm" label-width="100px" label-position="left">
        <el-form-item prop="name" :label="$t('integration.type_name')">
            <span v-if="isMode">
                {{ dioForm.name }}
            </span>
            <el-input v-else type="text" v-model="dioForm.name" style="width:250px"></el-input>
        </el-form-item>
        <el-form-item prop="code" :label="$t('integration.type_code')">
            <el-input v-if="handleText === 'add'" type="text" v-model="dioForm.code" style="width:250px"></el-input>
            <span v-else>
                {{ dioForm.code }}
            </span>
        </el-form-item>
        <el-form-item prop="status" :label="$t('integration.type_status')">
            <span v-if="isMode">
                {{ statusText(dioForm.status) }}
            </span>
            <el-select v-else v-model="dioForm.status" style="width:250px">
                <el-option v-for="item in typeStatus" :key="item.value" :value="item.value" :label="$t(item.label)"> </el-option>
            </el-select>
        </el-form-item>
        <el-form-item prop="description" :label="$t('public.table_desc')">
            <span v-if="isMode">
                {{ dioForm.description }}
            </span>
            <el-input v-else style="width:250px" maxlength="250" show-word-limit :autosize="{ minRows: 4, maxRows: 8 }" type="textarea" v-model="dioForm.description"> </el-input>
        </el-form-item>
    </el-form>
</template>

<script>
import { ruleFn } from '../../validate/validate.js';
export default {
    props: ['isMode', 'statusParam', 'detailContent', 'handleText'],
    computed: {
        rules() {
            const rules = ruleFn.call(this, ['name', 'code']);
            return rules;
        },
        typeStatus() {
            const list = (this.statusParam && this.statusParam.length > 0 && this.statusParam.slice(1)) || [];
            // Type Status 下拉中 public.stop 显示为"停用/Cancel"，这里改为专用 key"停用/Disable"
            return list.map(item => ({
                ...item,
                label: item.label === 'public.stop' ? 'public.type_status_disable' : item.label
            }));
        }
    },
    watch: {
        detailContent(newVal) {
            const { code, name, id, status, description, picture } = { ...newVal };
            this.dioForm = {
                code,
                name,
                id,
                status: String(status),
                description,
                picture
            };
        }
    },
    data() {
        return {
            dioForm: {
                name: '',
                code: '',
                status: '1',
                description: ''
            }
        };
    },
    methods: {
        clearValidate() {
            if (this.$refs.form) {
                this.$refs.form.resetFields();
            }
        },
        async justify() {
            try {
                return await this.$refs['form'].validate();
            } catch (error) {
                return false;
            }
        },
        statusText(status) {
            let str;
            for (let item of this.typeStatus) {
                if (item.value === String(status)) {
                    str = this.$t(item.label);
                    break;
                }
            }
            return str;
        }
    }
};
</script>

<style></style>
